import type { TFunction } from 'i18next';

const formatScoreOutOf = (t: TFunction, score: number, max: number, decimals: number): string => {
    return t('traineeReports:scoreOutOf', {
        score: Number(score).toFixed(decimals),
        max: String(max),
    });
};

export default formatScoreOutOf;
